import React, { useState } from "react";
import { Shell, Header } from "./Shell";
import { s } from "../lib/theme";
import { Auth, errMsg } from "../lib/api";

export default function Login({ onLoggedIn }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    setErr("");
    try {
      const me = await Auth.login(email.trim().toLowerCase(), password);
      onLoggedIn(me);
    } catch (e) {
      setErr(errMsg(e, "Sign-in failed."));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Shell header={<Header title="Time Off Tracker" sub="Sign in with your work email and password" />}>
      <div style={{ maxWidth: 380 }}>
        <label style={s.label}>Email</label>
        <input
          data-testid="login-email-input"
          style={s.input}
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@tnimplant.com"
          onKeyDown={(e) => e.key === "Enter" && submit()}
        />
        <label style={s.label}>Password</label>
        <input
          data-testid="login-password-input"
          style={s.input}
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="••••••••"
        />
        {err && <div data-testid="login-error" style={s.error}>{err}</div>}
        <button data-testid="login-submit-btn" disabled={busy} style={s.btnPrimary} onClick={submit}>
          {busy ? "Signing in…" : "Sign In"}
        </button>
        <div style={{ ...s.muted, marginTop: 18, fontSize: 12, lineHeight: 1.5 }}>
          Please submit PTO requests at least <strong>three weeks (21 days)</strong> in
          advance. Requests with shorter notice may be denied.
        </div>
      </div>
    </Shell>
  );
}
